import axios from 'axios';
import router from '../Router/index';

export default {
  namespaced: true,

  state: {
    sidebar_status: false,
    menuPart: ''
  },

  getters: {
    getSidebarStatus(state) {
      return state.sidebar_status;
    },
    getMenuPart(state) {
      return state.menuPart;
    }
  },

  mutations: {
    SET_SIDEBAR_STATUS(state, value) {
      state.sidebar_status = value;
    },
    SET_MENU_PART(state, value) {
      state.menuPart = value;
    }
  },

  actions: {
    setSidebarStatus({ commit }, value) {
      commit('SET_SIDEBAR_STATUS', value);
    },
    setMenuPart({ commit }, value) {
      commit('SET_MENU_PART', value);
    }
  }
};
